"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkType = void 0;
const Either_1 = require("fp-ts/Either");
const DataValidationError_1 = require("./DataValidationError");
function checkType(data, type) {
    const decoded = type.decode(data);
    return Either_1.getOrElse((error) => {
        throw new DataValidationError_1.DataValidationError(`Data did not conform to expected schema.\n\nExpected: ${type.name}.\n\nActual: ${JSON.stringify(data)}`, error);
    })(decoded);
}
exports.checkType = checkType;
//# sourceMappingURL=checkType.js.map